import { render, staticRenderFns } from "./merchantLabel.vue?vue&type=template&id=0d586493&scoped=true&"
import script from "./merchantLabel.vue?vue&type=script&lang=js&"
export * from "./merchantLabel.vue?vue&type=script&lang=js&"
import style0 from "./merchantLabel.vue?vue&type=style&index=0&id=0d586493&scoped=true&lang=css&"
import style1 from "./merchantLabel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d586493",
  null
  
)

export default component.exports